import { useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";

const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL ||
  "https://new-backend-production.apps.konnectbd.com";

export default function useKycSocket(
  onKycProgress,
  onKycCompleted
) {
  const [isConnected, setIsConnected] = useState(false);
  const [connectionError, setConnectionError] = useState(null);
  const socketRef = useRef(null);

  const callbacksRef = useRef({
    onKycProgress,
    onKycCompleted,
  });

  useEffect(() => {
    callbacksRef.current = {
      onKycProgress,
      onKycCompleted,
    };
  }, [onKycProgress, onKycCompleted]);

  useEffect(() => {
    const token = localStorage.getItem("konnect_token");

    if (!token) {
      console.log("❌ No authentication token found for KYC socket");
      return;
    }

    console.log("🔌 Initializing KYC socket connection...");
    console.log("📍 Socket URL:", `${SOCKET_URL}/delivery`);

    socketRef.current = io(`${SOCKET_URL}/delivery`, {
      auth: {
        token: token,
      },
      transports: ["websocket", "polling"],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
    });

    socketRef.current.on("connect", () => {
      console.log("✅ KYC socket connected!");
      console.log("🆔 Socket ID:", socketRef.current.id);
      setIsConnected(true);
      setConnectionError(null);
    });

    socketRef.current.on("disconnect", (reason) => {
      console.log("❌ KYC socket disconnected");
      console.log("📋 Reason:", reason);
      setIsConnected(false);
    });

    socketRef.current.on("connect_error", (error) => {
      console.error("⚠️ KYC socket connection error:", error.message);
      setIsConnected(false);
      setConnectionError(error.message);
    });

    socketRef.current.on("kyc:progress", (data) => {
      console.log("🔄 KYC PROGRESS UPDATE");
      console.log("📦 Progress data:", data);
      if (callbacksRef.current.onKycProgress) {
        callbacksRef.current.onKycProgress(data);
      }
    });

    socketRef.current.on("kyc completed", (data) => {
      console.log("✅ KYC VERIFICATION COMPLETED");
      console.log("📦 Completion data:", data);
      if (callbacksRef.current.onKycCompleted) {
        callbacksRef.current.onKycCompleted(data);
      }
    });

    socketRef.current.on("KYC complete", (data) => {
      console.log("✅ KYC VERIFICATION COMPLETED");
      console.log("📦 Completion data:", data);
      if (callbacksRef.current.onKycCompleted) {
        callbacksRef.current.onKycCompleted(data);
      }
    });

    socketRef.current.on("kyc:completed", (data) => {
      console.log("✅ KYC VERIFICATION COMPLETED");
      console.log("📦 Completion data:", data);
      if (callbacksRef.current.onKycCompleted) {
        callbacksRef.current.onKycCompleted(data);
      }
    });

    socketRef.current.onAny((eventName, ...args) => {
      console.log("📨 KYC socket event:", eventName, args);
    });

    socketRef.current.on("error", (error) => {
      console.error("⚠️ KYC socket error:", error);
      setConnectionError(error.message);
    });

    return () => {
      console.log("🧹 Cleaning up KYC socket connection");
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, []);

  return {
    isConnected,
    connectionError,
    socket: socketRef.current,
  };
}
